import type { SVGProps } from "react";

export function QuoteIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 10.663C21 6.439 16.959 3 12 3C7.041 3 3 6.439 3 10.663C3 14.446 6.201 17.621 10.527 18.223C11.58 18.462 11.459 18.867 11.223 20.356C11.184 20.594 11.039 21.288 12 20.868C12.96 20.448 17.18 17.667 19.073 15.388C20.377 13.884 21 12.359 21 10.673V10.663Z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function QuoteFilledIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 10.663C21 6.439 16.959 3 12 3C7.041 3 3 6.439 3 10.663C3 14.446 6.201 17.621 10.527 18.223C11.58 18.462 11.459 18.867 11.223 20.356C11.184 20.594 11.039 21.288 12 20.868C12.96 20.448 17.18 17.667 19.073 15.388C20.377 13.884 21 12.359 21 10.673V10.663Z"
        fill="currentColor"
      />
    </svg>
  );
}
